import { formatText } from './functions';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import CustomModalElements from '../components/Table/components/CustomModalElements';

export const DocumentHeaders: GridColDef[] = [
    {
        field: 'idDocumento',
        headerName: 'ID DOCUMENTO',
        minWidth: 300,
        flex: 1,
        align: 'left',
        resizable: false,
        sortable: false
    },
    {
        field: 'tipoDocumento',
        headerName: 'TIPO DE DOCUMENTO',
        minWidth: 200,
        resizable: false,
        flex: 1,
        sortable: false
    },
    {
        field: 'aplicacion',
        headerName: 'ORIGEN',
        minWidth: 120,
        flex: 1,
        resizable: false,
        sortable: false
    },
    {
        field: 'customId',
        headerName: 'REF. ADICIONAL',
        minWidth: 150,
        flex: 1,
        resizable: false,
        sortable: false
    },
    {
        field: 'fechaCreacion',
        headerName: 'CREACION',
        width: 200,
        type: 'dateTime',
        valueGetter: (value: string) => new Date(value),
        sortable: false
    },
    {
        field: 'vencimiento',
        headerName: 'VENCIMIENTO',
        minWidth: 120,
        flex: 1,
        resizable: false,
        valueGetter: (value: string) => value || 'Sin asignar',
        sortable: false
    },
    {
        field: 'cuilOperador',
        headerName: 'OPERADOR',
        minWidth: 120,
        flex: 1,
        sortable: false,
        resizable: false
    },
    {
        field: 'cuilPropietario',
        headerName: 'CUIL PROPIETARIO',
        minWidth: 120,
        flex: 1,
        sortable: false,
        resizable: false
    },
    {
        field: 'cuitPropietario',
        headerName: 'CUIT PROPIETARIO',
        minWidth: 120,
        flex: 1,
        sortable: false,
        resizable: false
    },
    {
        field: 'showDocuments'
    }
];

export const EnabledDocuments: GridColDef[] = [
    {
        field: 'documento',
        headerName: 'DOCUMENTO',
        minWidth: 150,
        align: 'left',
        resizable: false,
        flex: 1,
        valueGetter: (_: any, row: any) => {
            return row?.tipoDocumento?.nombre || '';
        },
        sortable: false
    },
    {
        field: 'cargar',
        headerName: 'CARGAR',
        width: 120,
        headerClassName: 'header-center',
        cellClassName: 'flex-center',
        renderCell: (params: GridRenderCellParams) => CustomModalElements(params?.row?.cargar),
        resizable: false,
        sortable: false
    },
    {
        field: 'descargar',
        headerName: 'DESCARGAR',
        width: 120,
        headerClassName: 'header-center',
        cellClassName: 'flex-center',
        renderCell: (params: GridRenderCellParams) => CustomModalElements(params?.row?.descargar),
        resizable: false,
        sortable: false
    },
    {
        field: 'eliminar',
        headerName: 'ELIMINAR',
        width: 120,
        headerClassName: 'header-center',
        cellClassName: 'flex-center',
        renderCell: (params: GridRenderCellParams) => CustomModalElements(params?.row?.eliminar),
        resizable: false,
        sortable: false
    }
];

export const RequestHistory: GridColDef[] = [
    {
        field: 'fecha',
        headerName: 'FECHA',
        sortable: false,
        width: 160,
        type: 'dateTime',
        valueGetter: (value: string) => new Date(value)
    },
    {
        field: 'tipoDocumento',
        headerName: 'TIPO DE DOCUMENTO',
        minWidth: 150,
        resizable: false,
        sortable: false
    },
    {
        field: 'cuil',
        headerName: 'CUIL',
        width: 120,
        resizable: false,
        sortable: false
    },
    {
        field: 'referencia',
        headerName: 'REFERENCIA',
        sortable: false,
        flex: 1
    }
];

export const DownloadHistory: GridColDef[] = [
    {
        field: 'idDocumento',
        headerName: 'ID DOCUMENTO',
        flex: 1,
        minWidth: 200,
        align: 'left',
        sortable: false
    },
    {
        field: 'fecha',
        headerName: 'FECHA',
        resizable: false,
        flex: 1,
        sortable: false,
        type: 'dateTime',
        valueGetter: (value: string) => new Date(value)
    },
    {
        field: 'tipoDocumento',
        headerName: 'TIPO DE DOCUMENTO',
        flex: 1,
        resizable: false,
        sortable: false
    }
];

export const AttachmentHistory: GridColDef[] = [
    {
        field: 'idDocumento',
        headerName: 'ID DOCUMENTO',
        flex: 1,
        minWidth: 200,
        align: 'left',
        sortable: false
    },
    {
        field: 'fecha',
        headerName: 'FECHA',
        resizable: false,
        flex: 1,
        sortable: false,
        type: 'dateTime',
        valueGetter: (value: string) => new Date(value)
    },
    {
        field: 'tipoDocumento',
        headerName: 'TIPO DE DOCUMENTO',
        minWidth: 90,
        resizable: false,
        sortable: false,
        flex: 1
    }
];

export const UsersHeaders: GridColDef[] = [
    {
        field: 'id',
        headerName: 'ID',
        width: 70,
        align: 'left',
        sortable: false
    },
    {
        field: 'cuil',
        headerName: 'CUIL',
        width: 150,
        resizable: false,
        sortable: false
    },
    {
        field: 'nombre',
        headerName: 'NOMBRE',
        width: 200,
        minWidth: 200,
        resizable: false,
        sortable: false,
        valueGetter: (value: string) => formatText(value)
    },
    {
        field: 'apellido',
        headerName: 'APELLIDO',
        width: 150,
        minWidth: 150,
        resizable: false,
        sortable: false,
        valueGetter: (value: string) => formatText(value)
    },
    {
        field: 'rol',
        headerName: 'ROL',
        width: 150,
        minWidth: 150,
        resizable: false,
        sortable: false,
        flex: 1,
        valueGetter: (_: any, row: any) => row?.rol?.nombre
    },
    {
        field: 'fechaCreacion',
        headerName: 'FECHA DE ALTA',
        resizable: false,
        minWidth: 180,
        width: 180,
        sortable: false,
        type: 'dateTime',
        flex: 1,
        valueGetter: (value: string) => new Date(value)
    }
];

export const RolesHeaders: GridColDef[] = [
    {
        field: 'id',
        headerName: 'ID',
        width: 70,
        align: 'left',
        sortable: false
    },
    {
        field: 'nombre',
        headerName: 'NOMBRE',
        width: 250,
        minWidth: 200,
        resizable: false,
        sortable: false
    },
    {
        field: 'descripcion',
        headerName: 'DESCRIPCION',
        width: 170,
        minWidth: 170,
        resizable: false,
        sortable: false,
        flex: 1
    }
];
